import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IDealCard } from 'src/app/modules/shared/models';
import { DataService } from 'src/app/services/data/data.service';
import {ToastrService} from "ngx-toastr";
import { AuthService } from 'src/app/services';

@Component({
  selector: 'app-dealcard',
  templateUrl: './dealcard.component.html',
  styleUrls: ['./dealcard.component.scss']
})
export class DealcardComponent implements OnInit {

  @Input("deal") deal!: IDealCard;
  @Input("isPreview") isPreview: boolean = false;

  @Input("userIsLoggedIn") userIsLoggedIn: boolean = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    private toastr: ToastrService,
  ) { 
    
  }

  ngOnInit(): void {
    // console.log("Deal card", this.deal, this.isPreview)

    if (!this.deal) {
      return;
    }

    if (!this.deal.dealImageUrl) {
      this.deal = {
        ...this.deal,
         dealImageUrl: "../../../../../assets/images/no-image-available.jpg"
       };
    }
  }

  dealSizeFormatted(): string {
    if (!this.deal || !this.deal.fundraiseSize) {
      return 'n/a';
    }

    // the size is already in millions, so just format it with the M suffix
    const size = this.deal.fundraiseSize;
    if (size >= 1000) {
      return "$" + (size / 1000).toFixed(1) + 'B';
    } else {
      return "$" + size.toFixed(0) + 'M';
    }
  }


  viewDeal(deal: IDealCard) {
    // console.log("Route to deal ", deal);

    if (deal == null) {
      this.toastr.error("Deal not found");
      return;
    }

    // is it a full deal view or a preview?
    if (this.isPreview) {
      // if the user is logged in, route to the preview page with the bu slug, otherwise route to the preview page without the bu slug
      if (this.userIsLoggedIn) {
        this.router.navigate(['/', this.dataService.getBuSlug(), 'deal-preview', deal.id]);
      } else {
        this.router.navigate(['/', 'deal-preview', deal.id]);
      }
    } else {
      // if it's not a preview then route to the deal details page
      this.router.navigate(['/', this.dataService.getBuSlug(), 'deals', deal.id]);
    } 
  }

}
